import PropTypes from 'prop-types';

export const basePermissioPropTypes = {
  add: PropTypes.bool.isRequired,
  authorize: PropTypes.bool.isRequired,
  cancel: PropTypes.bool.isRequired,
  change: PropTypes.bool.isRequired,
  delete: PropTypes.bool.isRequired,
  export: PropTypes.bool.isRequired,
  import: PropTypes.bool.isRequired,
  sync: PropTypes.bool.isRequired,
  view: PropTypes.bool.isRequired,
  hasAllViewPermission: PropTypes.bool.isRequired,
  model: PropTypes.string.isRequired,
};

const catalogsPropTypes = PropTypes.objectOf(PropTypes.shape(basePermissioPropTypes));

export const permissionPropTypes = PropTypes.shape({
  ...basePermissioPropTypes,
  catalogs: catalogsPropTypes,
  tabs: PropTypes.objectOf(PropTypes.shape({
    ...basePermissioPropTypes,
    catalogs: catalogsPropTypes,
  })),
});
